import { LazyLoadImage } from 'react-lazy-load-image-component';
import './HolidayLikeALocalImage.scss';
import { useState } from 'react';
import { HolidayLikeALocalSidebarImageProps, SanityEventCity, SanityEventCityImage } from '../HolidayLikeALocal.types';
import { sanityDataset, sanityImagesBaseUrl, sanityProjectId } from '../../../../sanity.io/config';
import Dropdown from 'app/atoms/Dropdown';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import SanityBody from '../../../atoms/Sanity/SanityBody/SanityBody';
import { Response } from 'types/response';
import useGet from 'services/useGet';
import { useEffect } from 'react';

export function parseCityImg(image: SanityEventCityImage) {
  return image.asset._ref.split('image-')[1].replace('-jpg', '.jpg').replace('-png', '.png');
}

function HolidayLikeALocalImage({ innerClass, start, end, cities, whereTo, setWhereTo }: HolidayLikeALocalSidebarImageProps) {
  const [img, setImg] = useState(parseCityImg(whereTo.image));

  function cityChange(location: string) {
    console.log(location);
    let selectedCity = cities.find(city => city.name === location);
    !!selectedCity && setWhereTo(selectedCity);
    !!selectedCity && setImg(parseCityImg(selectedCity.image));
  }

  const [propertiesNewAPIResult, getAllPropertiesNewAPI, isLoading] = useGet<Response>({
    url: '/properties',
    defaultValue: {}
  });

  useEffect(() => {
    getAllPropertiesNewAPI({ location: whereTo.name, checkInDate: start, checkOutDate: end });
  }, [whereTo]);

  let history = useHistory();
  const goToResults = () => {
    history.push({
      pathname: '/results',
      search: `?location=${whereTo.name}&checkInDate=${start}&checkOutDate=${end}&FlexibleDateRange=true&limit=6&sort=aToZ`
    });
  };

  return (
    <div className={'sanity-sidebar-main-container pl-sm-0 col-12 col-sm-4 my-4'}>
      <div className={`sanity-sidebar-sticky-img-div ${innerClass} flex-column`}>
        <div className="text-left text-lg-center slider-headin d-flex flex-column flex-lg-row align-items-center justify-content-center mb-2 pb-2">
          <h3 className="m-0 pr-2 pl-1 font_montserrat font-weight-normal col-12 col-lg-5">Holiday like a...</h3>
          {!!cities && !!cities.length && (
            <Dropdown
              mainClassName="px-0 col-12 col-lg-7"
              action={cityChange}
              inputField
              keyToSet={'text'}
              data={cities.map((each: SanityEventCity) => ({ text: each.demonym, value: each.name }))}
              defaultValue={whereTo.name}
              className="carousel-dropdown d-flex align-items-center justify-content-between p-2"
            />
          )}
        </div>
        <div className="image-and-title-container">
          <LazyLoadImage
            src={`${sanityImagesBaseUrl}/${sanityProjectId}/${sanityDataset}/${img}`}
            alt={whereTo.name}
            className="sanity-sidebar-image"
          />
          <div className="title">{whereTo.name}</div>
        </div>
        <div className="where-to-header">Why now is the time to go:</div>
        <SanityBody body={whereTo.text} />
        <Button
          type="button"
          disabled={isLoading}
          className="px-3 search-btn text-center sanity-sidebar-search-button btn btn-primary"
          onClick={() => goToResults()}
        >
          {`See the ${propertiesNewAPIResult.total_property_count} houses available for the holidays`}
        </Button>
      </div>
    </div>
  );
}

export default HolidayLikeALocalImage;
